import { IPrice, IQuote } from '@/src/api/homeServices/types';
import { useBoilerQuote } from './useBoilerQuote';

export const useAnnualBoilerServiceQuote = (): {
  price?: IPrice;
  quote?: IQuote;
  isLoading: boolean;
} => {
  const { data, isLoading } = useBoilerQuote(false, true); // needs repair, is abs

  const absQuote = data?.result[0]?.quotes[0];
  return {
    price: absQuote?.price,
    quote: absQuote,
    isLoading,
  };
};
